import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { useTenantAccess } from '../../hooks/useTenantAccess'
import { FullPageSpinner } from './Spinner'

const MODULE_LABELS: Record<string, string> = {
  logistics: 'Logistics',
  school: 'School',
  restaurant: 'Restaurant',
  hospitality: 'Hotel',
  manufacturing: 'Manufacturing',
  healthcare: 'Healthcare',
  real_estate: 'Real Estate',
  cooperative: 'Cooperative',
  professional: 'Professional Services',
}

const MODULE_REQUIRED_PLAN: Record<string, string> = {
  logistics: 'Growth',
  school: 'Growth',
  restaurant: 'Growth',
  hospitality: 'Growth',
  manufacturing: 'Growth',
  healthcare: 'Growth',
  real_estate: 'Growth',
  cooperative: 'Growth',
  professional: 'Growth',
}

interface ModuleGateProps {
  code: string
  children?: React.ReactNode
}

function Redirect({ code }: { code: string }) {
  const navigate = useNavigate()
  useEffect(() => {
    const label = MODULE_LABELS[code] ?? code
    const plan = MODULE_REQUIRED_PLAN[code] ?? 'Growth'
    toast.error(`${label} requires the ${plan} plan`)
    navigate('/dashboard', { replace: true })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}

export function ModuleGate({ code, children }: ModuleGateProps) {
  const { hasModule, isLoading } = useTenantAccess()

  if (isLoading) return <FullPageSpinner />
  if (!hasModule(code)) return <Redirect code={code} />
  return children ? <>{children}</> : <Outlet />
}
